/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: UGC Generator 跳转参数 Store
 */
import { createWithEqualityFn } from 'zustand/traditional';

import { ExtendedUploadFile } from '@/components/FileUpload';

/** 跳转目标类型 */
type TargetType = 'image-to-image' | null;

interface UGCNavigationFormData {
  prompt?: string;
  images?: ExtendedUploadFile[];
}

interface UGCNavigationState {
  /** 目标页面的 Tab Key */
  targetTabKey: string | null;
  /** 目标类型（用于区分不同的消费者） */
  targetType: TargetType;
  /** 表单数据 */
  formData: UGCNavigationFormData | null;
  /** 设置目标 Tab */
  setTargetTabKey: (tabKey: string | null) => void;
  /** 设置跳转数据 */
  setNavigationData: (type: TargetType, data: UGCNavigationFormData | null) => void;
  /** 消费并清除目标 Tab（读取后自动清除） */
  consumeTargetTabKey: () => string | null;
  /** 消费指定类型的表单数据（只有类型匹配时才消费） */
  consumeFormData: (type: TargetType) => UGCNavigationFormData | null;
}

export const useUGCNavigationStore = createWithEqualityFn<UGCNavigationState>()(
  (set, get) => ({
    targetTabKey: null,
    targetType: null,
    formData: null,

    setTargetTabKey: (tabKey) => {
      set({ targetTabKey: tabKey });
    },

    setNavigationData: (type, data) => {
      set({ targetType: type, formData: data });
    },

    consumeTargetTabKey: () => {
      const tabKey = get().targetTabKey;
      set({ targetTabKey: null });
      return tabKey;
    },

    consumeFormData: (type) => {
      const { targetType, formData } = get();
      // 只有类型匹配时才消费
      if (targetType === type && formData) {
        set({ targetType: null, formData: null });
        return formData;
      }
      return null;
    },
  }),
);
